import RaceImageInfo from './RaceImageInfo';

export default RaceImageInfo;
